module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_record-28d978ae3cc215557ffe485456a7e352.svg";